import { useQuery } from '@apollo/client'
import { GET_HUBS_SELECTED } from '@data/reactive-variables/hubs'
import { useMemo } from 'react'

export function useGetHubSelected() {
  const { data, ...result } = useQuery(GET_HUBS_SELECTED)
  const hubId = useMemo(() => data?.hubSelected?.id ?? '', [data])

  return {
    ...result,
    hubSelected: data?.hubSelected,
    hubId,
  }
}
